import { AuthRoles, AuthUser } from "@lib/types/Auth";
import adminRoutesConfig from "./adminRoutesConfig";
import adminManagementRoutesConfig from "./adminManagementRoutesConfig";
import customerManagerRoutesConfig from "./customerManagerRoutesConfig";
import customerRoutesConfig from "./customerRoutesConfig";
import providerRoutesConfig from "./providerRoutesConfig";

export const getRouteConfig = (role: AuthUser) => {
  switch (role?.role) {
    case AuthRoles.Admin: {
      return role.isManagement
        ? adminManagementRoutesConfig
        : adminRoutesConfig;
    }
    case AuthRoles.CustomerManager:
      return customerManagerRoutesConfig;
    case AuthRoles.CustomerAgent:
      return customerRoutesConfig;
    case AuthRoles.ProviderAgent:
      return providerRoutesConfig;
    default:
      return [];
  }
};
